// Filesystem.writeFile on native takes the payload as bare base64, without the data url prefix.
export const blobToBase64 = (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = () => reject(new Error('could not read the file'));
        reader.onload = () => {
            const dataUrl = String(reader.result);
            resolve(dataUrl.slice(dataUrl.indexOf(',') + 1));
        };
        reader.readAsDataURL(blob);
    });
};
